import { render, staticRenderFns } from "./linklist.vue?vue&type=template&id=6328446e&scoped=true&"
import script from "./linklist.vue?vue&type=script&lang=js&"
export * from "./linklist.vue?vue&type=script&lang=js&"
import style0 from "./linklist.vue?vue&type=style&index=0&id=6328446e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328446e",
  null
  
)

export default component.exports